import api from '../utils/api';

export async function listSubAgents(agentId, { page = 1, perPage = 20 } = {}) {
  const { data } = await api.get(`/agents/${agentId}/sub-agents`, {
    params: { page, per_page: perPage },
  });
  return data;
}

export async function getSubAgent(subAgentId) {
  const { data } = await api.get(`/sub-agents/${subAgentId}`);
  return data;
}

export async function createSubAgent(agentId, payload) {
  const { data } = await api.post(`/agents/${agentId}/sub-agents`, payload);
  return data;
}

export async function updateSubAgent(subAgentId, payload) {
  const { data } = await api.put(`/sub-agents/${subAgentId}`, payload);
  return data;
}

export async function deleteSubAgent(subAgentId) {
  const { data } = await api.delete(`/sub-agents/${subAgentId}`);
  return data;
}
